<template>
  <s-app class="bg-color-white sm:bg-color-neutral-50">
    <main>
      <router-view />
    </main>
    <cookie-banner
      :is-visible-initially="isVisibleBanner"
      :first-button-text="translate('AppointmentWizard.Cookies.LinkMessage')"
      :message="translate('AppointmentWizard.Cookies.Description')"
      :second-button-text="translate('AppointmentWizard.Cookies.CloseMessage')"
    />
    <div class="fixed bottom-0 z-10 w-full">
      <s-alerts-handler :messages="messages" @alert-message-closed="removeAlert" />
    </div>
    <div class="fixed bottom-0 h-fit w-20 sm:w-full">
      <footer-links v-if="useFooter && !isIntegrated" />
    </div>
  </s-app>
</template>

<script setup lang="ts">
import { useHead } from '@unhead/vue'
import { SAlertsHandler, SApp } from 'sima-suite-components-vue3'
import { useTranslator } from 'sima-suite-translator-vue3'
import { computed, ref } from 'vue'

import CookieBanner from '@/components/molecules/CookieBanner/CookieBanner.vue'
import FooterLinks from '@/components/molecules/FooterLinks/FooterLinks.vue'
import { useAlert, useHost } from '@/composables'
import { useVolkswagenIntegratorShell } from '@/integratorBoundary'

const { messages, removeAlert } = useAlert()
const { language, translate } = useTranslator()
const { brandFont, useFooter, useLocalCookieBanner, useVolkswagenIntegrator } = useHost()
const isVisibleBanner = computed(() => useLocalCookieBanner.value)
const fontFamily = ref(brandFont.value ? 'Brand Font' : 'Roboto')
const { isIntegrated } = useVolkswagenIntegratorShell(
  document.querySelector<HTMLElement>('#app'),
  useVolkswagenIntegrator.value
)

useHead({
  htmlAttrs: {
    lang() {
      return language.value
    }
  }
})

if (brandFont.value) {
  const brandFontElement = document.createElement('style')
  brandFontElement.appendChild(
    document.createTextNode(`
        @font-face {
          font-family: 'Brand Font';
          src: url('/fonts/${brandFont.value}');
        }
      `)
  )
  document.head.appendChild(brandFontElement)
}
</script>

<style>
#app,
#app * {
  font-family: v-bind(fontFamily) !important;
  line-height: 1.5 !important;
}
</style>
